import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  DELETE_USER_BUTTON: `${cleanedFilename(__filename)}-delete-user-button`,
  RESEND_INVITATION_BUTTON: `${cleanedFilename(
    __filename,
  )}-resend-invitation-button`,
};
